import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url } from '../model/users.model';
import { FuelLevy } from '../model/fuellevy.model';

@Injectable()
export class FuelLevyService {
    @LocalStorage() url: Url;
    private headers = new Headers({ 'Content-Type': 'application/json' });
  
    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
        'Content-Type': 'application/json'
        })
    }
  
    constructor(public http:HttpClient) { }

    getFuelLevies(): Observable<any> { 
        return this.http.get<any>( this.url.rest + '/tms/getFuelLevies')
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    addFuelLevy(fuel_levy:FuelLevy) : Observable<any> { 
        return this.http.post<any>( this.url.rest + '/tms/createFuelLevy', fuel_levy)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    updateFuelLevy(fuel_levy:FuelLevy): Observable<any> {
        return this.http.post<any>(this.url.rest + '/tms/updateFuelLevy', fuel_levy)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    deleteFuelLevy(fuel_levy:FuelLevy): Observable<any> {
        return this.http.post<any>(this.url.rest + '/tms/deleteFuelLevy', fuel_levy)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }

}